import { motion } from 'framer-motion';
import AnimatedSection, { staggerContainer, fadeUpVariant } from './AnimatedSection';
import './WhyOneLedger.scss';

const features = [
  {
    num: '01',
    title: 'Upfront Capital',
    desc: 'Capital deployed per shipment. Every trade gets the funding it needs on day one.',
  },
  {
    num: '02',
    title: 'Execution Control',
    desc: 'We track shipments in real time. Risk managed at the load level, not the portfolio level.',
  },
  {
    num: '03',
    title: 'Faster Payments',
    desc: 'Settlement triggered on delivery. No more 30–90 day waits breaking cash flow.',
  },
  {
    num: '04',
    title: 'Built for Africa',
    desc: 'Corridor-specific, counterparty-aware, and operationally grounded in African freight.',
  },
];

export default function WhyOneLedger() {
  return (
    <section className="why-oneledger">
      <div className="container">
        <AnimatedSection className="why-oneledger__header">
          <p className="why-oneledger__label">Why OneLedger</p>
          <h2 className="why-oneledger__title">Infrastructure, not just financing</h2>
        </AnimatedSection>

        <motion.div
          className="why-oneledger__grid"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          {features.map(({ num, title, desc }) => (
            <motion.div key={num} className="why-oneledger__feature" variants={fadeUpVariant}>
              <span className="why-oneledger__feat-num">{num}</span>
              <h3 className="why-oneledger__feat-title">{title}</h3>
              <p className="why-oneledger__feat-desc">{desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
